"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_MENU = exports.SHOW_MENU = "SHOW_MENU";
var CHANGE_BOTTOM_NAVIGATION_INDEX = exports.CHANGE_BOTTOM_NAVIGATION_INDEX = "CHANGE_BOTTOM_NAVIGATION_INDEX";
var SHOW_DIALOG = exports.SHOW_DIALOG = "SHOW_DIALOG";
var SHOW_TOAST = exports.SHOW_TOAST = "SHOW_TOAST";
var SET_LOGO = exports.SET_LOGO = "SET_LOGO";
var SET_APP_NAME = exports.SET_APP_NAME = "SET_APP_NAME";
var SET_ROUTE = exports.SET_ROUTE = "SET_ROUTE";
var ADD_LOCALIZATION = exports.ADD_LOCALIZATION = "ADD_LOCALIZATION";
var UPDATE_LOCALIZATION = exports.UPDATE_LOCALIZATION = "UPDATE_LOCALIZATION";
var SET_USER_INFO = exports.SET_USER_INFO = "SET_USER_INFO";
var SET_USER_CURRENT_LOCATION = exports.SET_USER_CURRENT_LOCATION = "SET_USER_CURRENT_LOCATION";
var ADD_BREADCRUMB_ITEM = exports.ADD_BREADCRUMB_ITEM = "ADD_BREADCRUMBS_ITEM";
var REMOVE_BREADCRUMB_ITEM = exports.REMOVE_BREADCRUMB_ITEM = "REMOVE_BREADCRUMB_ITEM";
var FETCH_ACTIONMENU = exports.FETCH_ACTIONMENU = "FETCH_ACTIONMENU";
var FETCH_UI_COMMON_CONFIG = exports.FETCH_UI_COMMON_CONFIG = "FETCH_UI_COMMON_CONFIG";
var FETCH_UI_COMMON_CONSTANTS = exports.FETCH_UI_COMMON_CONSTANTS = "FETCH_UI_COMMON_CONSTANTS";
var UPDATE_ACTIVE_ROUTE_PATH = exports.UPDATE_ACTIVE_ROUTE_PATH = "UPDATE_ACTIVE_ROUTE_PATH";
var SET_PREVIOUS_ROUTE = exports.SET_PREVIOUS_ROUTE = "SET_PREVIOUS_ROUTE";
var GET_NOTIFICATION_COUNT = exports.GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT";
var GET_NOTIFICATIONS_COMPLETE = exports.GET_NOTIFICATIONS_COMPLETE = "GET_NOTIFICATIONS_COMPLETE";
var GET_NOTIFICATIONS_PENDING = exports.GET_NOTIFICATIONS_PENDING = "GET_NOTIFICATIONS_PENDING";
var GET_NOTIFICATIONS_ERROR = exports.GET_NOTIFICATIONS_ERROR = "GET_NOTIFICATIONS_ERROR";
var FETCH_INBOX_COUNT = exports.FETCH_INBOX_COUNT = "FETCH_INBOX_COUNT";
var FETCH_INBOX_RECORDS = exports.FETCH_INBOX_RECORDS = "FETCH_INBOX_RECORDS";
var FETCH_INBOX_RECORDS_ERROR = exports.FETCH_INBOX_RECORDS_ERROR = "FETCH_INBOX_RECORDS_ERROR";
var FETCH_INBOX_RECORDS_PENDING = exports.FETCH_INBOX_RECORDS_PENDING = "FETCH_INBOX_RECORDS_PENDING";
var FETCH_REM_INBOX_RECORDS_COMPLETE = exports.FETCH_REM_INBOX_RECORDS_COMPLETE = "FETCH_REM_INBOX_RECORDS_COMPLETE";
var FETCH_REM_INBOX_RECORDS_ERROR = exports.FETCH_REM_INBOX_RECORDS_ERROR = "FETCH_REM_INBOX_RECORDS_ERROR";
var FETCH_REM_INBOX_RECORDS_PENDING = exports.FETCH_REM_INBOX_RECORDS_PENDING = "FETCH_REM_INBOX_RECORDS_PENDING";
var FETCH_RESET_INBOX_RECORDS = exports.FETCH_RESET_INBOX_RECORDS = "FETCH_RESET_INBOX_RECORDS";
var FETCH_ACTIONMENU_PENDING = exports.FETCH_ACTIONMENU_PENDING = "FETCH_ACTIONMENU_PENDING";
var FETCH_ACTIONMENU_ERROR = exports.FETCH_ACTIONMENU_ERROR = "FETCH_ACTIONMENU_ERROR";
var FETCH_ESCALATED_INBOX_RECORDS_COMPLETE = exports.FETCH_ESCALATED_INBOX_RECORDS_COMPLETE = "FETCH_ESCALATED_INBOX_RECORDS_COMPLETE";
var FETCH_CITIZEN_CONSENT_FORM = exports.FETCH_CITIZEN_CONSENT_FORM = "FETCH_CITIZEN_CONSENT_FORM";
var SHOW_SNACKBAR = exports.SHOW_SNACKBAR = "SHOW_SNACKBAR";
var FETCH_FINANCIAL_YEARS = exports.FETCH_FINANCIAL_YEARS = "FETCH_FINANCIAL_YEARS";
var FETCH_DASHBOARD_FILTERS_DETAILS = exports.FETCH_DASHBOARD_FILTERS_DETAILS = "FETCH_DASHBOARD_FILTERS_DETAILS";
var FETCH_ZONE_DETAILS = exports.FETCH_ZONE_DETAILS = "FETCH_ZONE_DETAILS";
var FETCH_REVENUE_TREND = exports.FETCH_REVENUE_TREND = "FETCH_REVENUE_TREND";
var FETCH_WORKORDER_BY_CATEGORY = exports.FETCH_WORKORDER_BY_CATEGORY = "FETCH_WORKORDER_BY_CATEGORY";
var FETCH_WORKORDER_BY_STATUS = exports.FETCH_WORKORDER_BY_STATUS = "FETCH_WORKORDER_BY_STATUS";
var SHOW_LOADER = exports.SHOW_LOADER = "SHOW_LOADER";
var SHOW_TABLE = exports.SHOW_TABLE = "SHOW_TABLE";
var FETCH_TOTAL_GRANT = exports.FETCH_TOTAL_GRANT = "FETCH_TOTAL_GRANT";
var FETCH_FILTER_API = exports.FETCH_FILTER_API = "FETCH_FILTER_API";
var FETCH_CONTRACTOR_DETAILS = exports.FETCH_CONTRACTOR_DETAILS = "FETCH_CONTRACTOR_DETAILS";
var FETCH_SUPPLIER_DETAILS = exports.FETCH_SUPPLIER_DETAILS = "FETCH_SUPPLIER_DETAILS";
var FETCH_OPENING_BALANCE_DETAILS = exports.FETCH_OPENING_BALANCE_DETAILS = "FETCH_OPENING_BALANCE_DETAILS";
var FETCH_EXPENDITURE_DETAILS = exports.FETCH_EXPENDITURE_DETAILS = "FETCH_EXPENDITURE_DETAILS";
var FETCH_PURCHASE_ORDER_DETAILS = exports.FETCH_PURCHASE_ORDER_DETAILS = "FETCH_PURCHASE_ORDER_DETAILS";
var FETCH_EXPENDITURE_FUND_DETAILS = exports.FETCH_EXPENDITURE_FUND_DETAILS = "FETCH_EXPENDITURE_FUND_DETAILS";
var FETCH_WORKORDER_DETAILS = exports.FETCH_WORKORDER_DETAILS = "FETCH_WORKORDER_DETAILS";
var FETCH_WORKORDER_FUND_DETAILS = exports.FETCH_WORKORDER_FUND_DETAILS = "FETCH_WORKORDER_FUND_DETAILS";
var FETCH_PURCHASE_ORDER_FUND_DETAILS = exports.FETCH_PURCHASE_ORDER_FUND_DETAILS = "FETCH_PURCHASE_ORDER_FUND_DETAILS";
var FETCH_RECEIPT_DETAILS = exports.FETCH_RECEIPT_DETAILS = "FETCH_RECEIPT_DETAILS";
var FETCH_DEPARTMENT_RECEIPT_DETAILS = exports.FETCH_DEPARTMENT_RECEIPT_DETAILS = "FETCH_DEPARTMENT_RECEIPT_DETAILS";
var FETCH_SCHEME_DETAIL_GRANT = exports.FETCH_SCHEME_DETAIL_GRANT = "FETCH_SCHEME_DETAIL_GRANT";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/app/actionTypes.js
// module id = ../lib/egov-ui-kit/redux/app/actionTypes.js
// module chunks = 504